// src/components/Boxes/Overview/overviewTransactions.component.jsx
import React, { useEffect, useMemo, useState } from "react";
import { buildAuthedJsonBody, getUserFromToken } from "../../../../utils/functions.ts";

const OverviewTransactions = ({ FBXID }) => {
  const playerId = useMemo(() => {
    const n = Number(FBXID);
    return Number.isFinite(n) && n > 0 ? n : null;
  }, [FBXID]);

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  useEffect(() => {
    const controller = new AbortController();

    const fetchTransactions = async () => {
      setRows([]);
      setErrMsg("");

      if (!playerId) return;

      setLoading(true);

      const token = await getUserFromToken().catch(() => null);
      if (!token?.team) {
        setLoading(false);
        setErrMsg("Missing user/team token.");
        return;
      }

      try {
        const res = await fetch("https://www.fbxchange.com/ReactPHP/overview.php", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          signal: controller.signal,
          body: buildAuthedJsonBody({
            FBXID: playerId,
            myTeam: token.team,
            script: "getTransactions",
          }),
        });

        const raw = await res.text();

        let data;
        try {
          data = JSON.parse(raw);
        } catch (e) {
          console.error("overview.php getTransactions not JSON:", raw);
          setErrMsg("Backend did not return JSON.");
          setLoading(false);
          return;
        }

        setRows(Array.isArray(data) ? data : []);
        setLoading(false);
      } catch (e) {
        if (e?.name === "AbortError") return;
        console.error("getTransactions fetch error:", e);
        setErrMsg("Network error loading transactions.");
        setLoading(false);
      }
    };

    fetchTransactions();
    return () => controller.abort();
  }, [playerId]);

  return (
    <div className="container-fluid p-0">
      {/* This outer wrapper does NOT scroll. Parent scrolls (Overview expanded area). */}
      <div className="row g-0">
        <div className="col-48">
          {/* Your column header row: sticky */}
          <div
            className="row g-1 bg-navy text-lemon fs-7 py-2 px-2"
            style={{ position: "sticky", top: 0, zIndex: 25 }}
          >
            <div className="col-8">Date</div>
            <div className="col-4">Team</div>
            <div className="col-4">Status</div>
            <div className="col-4">Pos</div>
            <div className="col-4">League</div>
            <div className="col-22">Notes</div>
          </div>

          {/* Body */}
          <div className="p-2">
            {loading ? (
              <div className="text-muted fs-7">
                <em>Loading transactions...</em>
              </div>
            ) : errMsg ? (
              <div className="alert alert-warning py-2 mb-0 fs-7">{errMsg}</div>
            ) : rows.length === 0 ? (
              <div className="text-muted small">
                <em>No transactions found.</em>
              </div>
            ) : (
              rows.map((t) => (
                <div key={t.ID} className="row g-1 border-bottom py-1 px-1 fs-7 align-items-center">
                  <div className="col-8">{t.ProTeamDate || "-"}</div>
                  <div className="col-4">{t.ProTeam || "-"}</div>
                  <div className="col-4">{t.ProTeamStatus || "-"}</div>
                  <div className="col-4">{t.PRO_POS || "-"}</div>
                  <div className="col-4">{t.League || "-"}</div>

                  <div className="col-22 text-truncate">
                    <span
                      className="d-inline-block text-truncate"
                      style={{ maxWidth: "100%" }}
                      title={t.ST_NOTES || "-"}
                    >
                      {t.ST_NOTES || "-"}
                    </span>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OverviewTransactions;
